import { Link } from "react-router-dom";

import Icon from "../../components/Icon";
import type { FuelHistoryEntry } from "../../api/types";
import { relativeDate } from "../../lib/date";

interface LastFillupSectionProps {
  entry: FuelHistoryEntry;
}

export default function LastFillupSection({ entry }: LastFillupSectionProps) {
  return (
    <section className="last-fillup">
      <div className="last-fillup__header">Last fill-up</div>
      <Link to="/history" className="entry-row entry-row--selectable">
        <div className="entry-row__main">
          <div className="entry-row__title">{entry.station_name}</div>
          <div className="entry-row__meta">
            <Icon name="pin" className="entry-row__meta-icon" />
            <span>
              {entry.city}, {entry.country}
            </span>
            <span className="entry-row__dot">·</span>
            <Icon name="calendar" className="entry-row__meta-icon" />
            <span>{relativeDate(entry.datetime)}</span>
          </div>
        </div>
        <div className="entry-row__side">
          <div className="entry-row__amount">
            {entry.amount_eur.toFixed(2)}
            <span>€</span>
          </div>
          <div className="entry-row__liters">{entry.liters.toFixed(1)} L</div>
        </div>
      </Link>
    </section>
  );
}
